import { render, staticRenderFns } from "./TextCaptionCard.vue?vue&type=template&id=1975d73a&scoped=true"
import script from "./TextCaptionCard.vue?vue&type=script&lang=js"
export * from "./TextCaptionCard.vue?vue&type=script&lang=js"
import style0 from "./TextCaptionCard.vue?vue&type=style&index=0&id=1975d73a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1975d73a",
  null
  
)

export default component.exports